<div class="content-container">
  <capra-icon class="centered-icon loading" icon="illo-loading" *ngIf="dataSourceTabContent.isLoading">
    <span>Loading...</span>
  </capra-icon>
  <ng-container *ngIf="!dataSourceTabContent.isLoading">
    <div *ngIf="!dataSourceTabContent.searchEmptyState && dataSourceTabContent.dataSources.length === 0">
      <capra-icon
        icon="icon-dataset"
        class="no-datasets"
        *ngIf="datasetTabType === 'workspace'; else renderPersonalEmptyState"
      >
        <h3>There are no Datasets to show</h3>
        <p>Datasets that are moved to Workspace Collections will appear here</p>
      </capra-icon>
      <ng-template #renderPersonalEmptyState>
        <capra-icon icon="illo-air-ballon" class="paste-url no-datasets" width="72px" height="72px">
          <h3>You don’t have any Personal Datasets to display</h3>
        </capra-icon>
      </ng-template>
    </div>

    <div
      class="input-form"
      *ngIf="
        (dataSourceTabContent.searchEmptyState || dataSourceTabContent.dataSources.length !== 0) &&
        !dataSourceTabContent.isLoading
      "
    >
      <capra-search-input
        class="search-input"
        size="regular"
        placeholder="Search for a Dataset..."
        [autofocus]="true"
        [text]="dataSourceTabContent.searchTerm"
        (textChange)="filterResults($event)"
      ></capra-search-input>
    </div>
    <div *ngIf="dataSourceTabContent.searchEmptyState && dataSourceTabContent.dataSources.length === 0">
      <capra-icon icon="illo-search-empty-state" class="empty-search">
        <h3>No Datasets match the search</h3>
        <span>
          {{ datasetTabType === 'workspace' ? NO_SEARCH_RESULTS_WORKSPACE : NO_SEARCH_RESULTS_PERSONAL }}
        </span>
      </capra-icon>
    </div>
    <div *ngIf="!dataSourceTabContent.isLoading && dataSourceTabContent.dataSources.length > 0">
      <mode-dataset-search-data-table
        [dataSource]="dataSourceTabContent.dataSources"
        (selectDataset)="selectedDataset($event)"
        [datasetsPagination]="dataSourceTabContent.pagination"
        (changeCurrentPage)="handleChangeCurrentPage($event)"
        [displayedColumns]="dataSourceTabContent.displayedColumns"
      ></mode-dataset-search-data-table>
    </div>
  </ng-container>
</div>
